import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import { Box } from "@quarkly/widgets";
export default function StackItemContent(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    "box-sizing": "border-box",
    "min-height": "100%",
    display: "flex",
    flex: "1 1 auto"
  }, props, {
    "data-qkind": "StackItemContent"
  }));
}
StackItemContent.effects = {
  hover: ":hover"
};